import {DefaultTheme} from 'styled-components';
import { colors } from './colors';
// 색상 이외의 수치 관련 모음
export const rootFixedSize = {
  rootFontSize: '16px',
  rootTitleFontSize: '1.25rem',
  // input/select
  inputPadding: '0.625rem 1rem 0.625rem 0.625rem',
  inputShortPadding: '0.5rem 1rem 0.5rem 0.625rem',
  inputBorderRadius: '0.25rem',
  // default-btn
  defaultBtnPadding: '0.5rem 1rem',
  defaultBtnBorderRadius: '0.5rem',
  // page-btn
  pagenationBtnPadding: '0.5rem',
  pagenationBtnBorderRadius: '0.25rem',
  // icon-btn
  iconBtnWidth: '3rem',
  iconBtnHeight: '3rem',
  iconBtnBorderRadius: '0.5rem',
  // info-icon
  infoIconPadding: '0.25rem 0.5rem',
  infoIconBorderRadius: '0.75rem',
  // container
  containerBorderRadius: '1rem',
  // table
  tableTheadThPadding: '0.75rem 0.5rem',
  tableTheadThBorderRadius: '0.5rem',
  tableTbodyTdPadding: '0.5rem',
  tableTbodyTdBorderRadius: '0.5rem',
  // controller
  controllerBorderRadius: '0.6rem',
};
// theme 색상과 상관없는 고정 색상
export const rootFixedColor = {
  // header/sidebar/footer용
  rootTextColor: '#ffffff',
  rootTextColorB: '#121212',
  rootBgColor: '#222222',
  footerColor: '#898989',
  // border
  borderPrimary: '#a9a9a9',
  // button
  buttonDefaultColor: 'rgb(232 233 235)',
  buttonDefaultHoverColor: 'rgb(232 233 235 / 60%)',
  btnDeleteBgColor: 'rgb(203 30 75)',
  btnDeleteBgHoverColor: 'rgb(203 30 75 / 60%)',
  btnEditBgColor: 'rgb(49 133 156)',
  btnEditBgHoverColor: 'rgb(49 133 156 / 40%)',
  btnListBgColor: '#FFFFFF',
  btnListBgHoverColor: 'rgb(255 255 255 / 50%)',

  primaryColor: 'rgb(49 133 156)',
  secondaryColor: '#a9a9a9',
  accentColor: '#F2AA4C',
  deleteColor: '#D2302C',
  statusNormalColor: '#2faf5b',
  statusErrorColor: '#e33f3f',
  statusOffColor: '#a9a9a9',
  eventColor1: 'rgb(247, 150, 70)',
  eventColor2: 'rgb(85, 142, 213)',
  eventColor3: 'rgb(255, 0, 0)',
};
// Map에서 사용되는 색상/치수
export const mapFixedColor = {
  // 색상
  mainBgColor: '#121212',
  mainTextColor: '#f2f3f5',
  mapBorderColor: '#b5b5b5',
  mapBntBgColor: 'rgb(49 133 156)',
  mapBntBgColorHover: 'rgb(49 133 156 / 60%)',
  // 색상 이외
  defaultBorderRadius: '0.5rem',
  listBorderRadius: '0.5rem',
  btnBorderRadius: '0.5rem',
};

/**
 * Partial<DefaultTheme>를 사용하게 되면, 이 타입의 모든 속성이 선택 사항이 됨
 * connected?: { success?: string, ... } 이런식으로 정의되는 것
 * 즉, 모든 속성을 다 적지 않아도 됨
 */
export const commonTheme: Partial<DefaultTheme['newTheme']> = {
  fix: {
    background: colors.fixBackground,
    secondaryBg: colors.secondary,
    textColor: colors.fixTextColor,
    secondaryText: colors.fixSecondaryTextColor,
  },
  root: {
    black: colors.black,
    white: colors.white,
    background: colors.darkLayer1,
    textColor: colors.white,
    primary: colors.primary_blue,
    primaryPink: colors.primary_pink,
    lightPrimary: colors.lightPrimary,
    secondary: colors.secondary,
    important: colors.important,
  },
  connected: {
    success: colors.success,
    unconnected: colors.error,
    off: colors.off,
  },
  envSensorStatus: {
    veryBad: colors.veryBad,
    bad: colors.bad,
    normal: colors.normal,
    good: colors.good,
    veryGood: colors.veryGood,
  },
  button: {
    defaultText: colors.btnDefaultText,
    primaryBtnBg: colors.primary_blue,
    primaryPinkBtnBg: colors.primary_pink,
    secondaryBtnBg: colors.secondary,
    whiteBtnBg: colors.whiteBtnBg,
    deleteBtnBg: colors.deleteBg,
    disabledBtnBg: colors.disabledBg,
    disabledBtnText: colors.disabledText,
    whiteBtnBorder: colors.darkWhiteBtnBorder,
  },
  input: {
    disabledBg: colors.darkInputReadOnlyBg,
    disabledText: colors.darkInputReadOnlyText,
  },
  icon: {
    defaultText: colors.iconDefaultText,
    iconLabel: colors.iconLabel,
    event1: colors.eventColor1,
    event2: colors.eventColor2,
    event3: colors.eventColor3,
  },
};

// 다크모드(기본)
export const darkTheme: DefaultTheme = {
  // root의 기본 색상
  rootTextColor: '#ffffff',
  rootBgColor: '#222222',
  newTheme: {
    ...(commonTheme as DefaultTheme['newTheme']),
    layer: {
      layer1: colors.darkLayer1,
      layer2: colors.darkLayer2,
      layer3: colors.darkLayer3,
    },
    button: {
      ...(commonTheme as DefaultTheme['newTheme']).button,
      primaryBtnBg: colors.darkPrimaryBtnBg,
      whiteBtnBorder: colors.darkWhiteBtnBorder,
    },
    scrollbar: {
      thumbColor: colors.darkScrollbarThumbColor,
      trackColor: colors.darkScrollbarTrackColor,
    },
    border: {
      ...(commonTheme as DefaultTheme['newTheme']).border,
      primaryBd: colors.primary_blue,
    },
    table: {
      ...(commonTheme as DefaultTheme['newTheme']).table,
      headBg: colors.darkTableHeadBg,
      bodyHoverBg: colors.darkTableHeadHoverBg,
      borderColor: colors.darkTableHeadHoverBg,
    }
  },
  // 기본적인 블랙/화이트 사용 시
  black: '#ffffff',
  white: '#121212',
  noneWhite: 'none',

  // layer의 배경 색상
  mainBgColor: '#121212',
  layer2BgColor: '#333533',
  boxBgColor: '#252525',
  // layer2일때 box-shadow 다크모드 - x, 라이트모드 - o
  layer2BoxShadow: 'none',
  layer3BgColor: '#4d4d4f',
  layer4BgColor: '#636363',
  layer5BgColor: '#C5C8CE',
  // border
  borderPrimary: '#E2E5EB',
  borderSecondary: '#EBEEF1',
  borderTertiary: '#5d615d',
  borderAccent: 'rgb(49 133 156)',
  // table
  // 기본 테이블
  tableHeadBgColor: 'rgb(55, 96, 146)',
  tableHeadTextColor: '#F2F3F5',
  tableBodyThBgColor: '#333533',
  tableBodyTdBgColor: '#333533',
  tableBodyTrHoverBgColor: 'rgb(55 96 146 / 50%)',
  tableBodyTextColor: '#F2F3F5',
  tableBorderColor: 'rgb(55 96 146 / 50%)',
  tableHiddenTrBgColor: '#474747',
  tableHiddenTdColor: '#979797',
  // 장비정보 테이블
  recorderTableHeadBgColor: '#636363',
  recorderTableBodyTrHoverBgColor: '#6969694f',

  // 제어페이지 배경
  controlBgImage:
    "url('/image/smartshelter_night.png') no-repeat scroll center / cover",

  //
  primaryColor: '#1568dd', // focus blue
  primaryColor_pink: '#e4007f', // focus pink
  //input
  readOnlyColor: '#222222',
  readOnlyTextColor: '#dbdbdb',
  errorMsgTextColor: '#ffcc54',

  // button
  buttonAccent: 'rgb(49 133 156)',
  buttonAccentHover: 'rgb(49 133 156 / 40%)',
  cameraIconFill: '#f2f3f5',

  // info-icon
  infoIconBgColor: '#7d7d80',
  // 원격제어 모달
  iconBorderColor: '#777777',
  // scroll-bar
  scrollbarThumbColor: '#999999',
  scrollbarTrackColor: '#555555',
  // range-bar
  sliderRunnableTrackColor: '#6F6F72',

  textColor: '#F2F3F5',
  bgColor: '#121212',
  borderColor: '#5B5B5E',
  subContainerBgColor: '#333533',

  buttonBgColor: '#5B5B5E',
  buttonActiveBgColor: '#f4f4f4',
};
// 라이트모드
export const lightTheme: DefaultTheme = {
  // root의 기본 색상
  rootTextColor: '#121212',
  rootBgColor: '#ffffff',
  newTheme: {
    ...(commonTheme as DefaultTheme['newTheme']),
    root: {
      ...(commonTheme as DefaultTheme['newTheme']).root,
      background: colors.lightLayer1,
      textColor: colors.lightText,
    },
    layer: {
      layer1: colors.lightLayer1,
      layer2: colors.lightLayer2,
      layer3: colors.lightLayer3,
    },
    button: {
      ...(commonTheme as DefaultTheme['newTheme']).button,
      primaryBtnBg: colors.lightPrimaryBtnBg,
      whiteBtnBorder: colors.lightWhiteBtnBorder,
    },
    input: {
      disabledBg: colors.lightInputReadOnlyBg,
      disabledText: colors.lightInputReadOnlyText,
    },
    scrollbar: {
      thumbColor: colors.lightScrollbarThumbColor,
      trackColor: colors.lightScrollbarTrackColor,
    },
    border: {
      ...(commonTheme as DefaultTheme['newTheme']).border,
      primaryBd: colors.lightPrimary,
    },
    table: {
      ...(commonTheme as DefaultTheme['newTheme']).table,
      headBg: colors.lightTableHeadBg,
      bodyHoverBg: colors.lightTableHeadHoverBg,
      borderColor: colors.lightTableHeadHoverBg,
    }
  },
  // 기본적인 블랙/화이트 사용 시
  black: '#121212',
  white: '#ffffff',
  noneWhite: '#ffffff',
  // layer1의 배경 색상
  mainBgColor: '#F2F3F5',
  layer2BgColor: '#fdfdfd',
  //
  boxBgColor: '#fdfdfd',
  // layer2일때 box-shadow 다크모드 - x, 라이트모드 - o
  layer2BoxShadow: '1px 1px 3px 1px #d3d3d3',
  layer3BgColor: '#d8d8d9',

  layer4BgColor: '#636363',
  layer5BgColor: '#C5C8CE',
  // border
  borderPrimary: '#E2E5EB',
  borderSecondary: '#EBEEF1',
  borderTertiary: '#5d615d',
  borderAccent: '#F2AA4C',
  // table - 완료
  // 기본 테이블
  tableHeadBgColor: '#f9ce95',
  tableHeadTextColor: '#121212',
  tableBodyThBgColor: '#fdfdfd',
  tableBodyTdBgColor: '#fdfdfd',
  tableBodyTrHoverBgColor: 'rgb(249 206 149 / 50%)',
  tableBodyTextColor: '#121212',
  tableBorderColor: '#f2f3f5',
  tableHiddenTrBgColor: '#DDDDDD',
  tableHiddenTdColor: '#979797',
  // 장비정보 테이블
  recorderTableHeadBgColor: '#6969694f',
  recorderTableBodyTrHoverBgColor: '#69696930',

  controlTableBodyBgColor: '#fff7ed',
  controlTableBodyBorderColor: '#614c54',
  controlTablePageBtnBgColor: '#333533',
  controlTablePageBtnHoverBgColor: '#4f4f4f',
  controlTablePageBtnTextColor: '#F2F3F5',
  controlTableComponentBgColor: '#fff7ed',
  // 제어페이지 배경
  controlBgImage:
    "url('/image/smartshelter_day.png') no-repeat scroll center / cover",

  //
  primaryColor: 'rgb(242 170 76)',
  //input
  readOnlyColor: '#b1b1b1',
  readOnlyTextColor: '#393939',
  errorMsgTextColor: '#A4193D',
  // button
  buttonAccent: 'rgb(242 170 76)',
  buttonAccentHover: 'rgb(242 170 76 / 40%)',
  cameraIconFill: '#333333',
  // info-icon
  infoIconBgColor: '#d8d8d9',
  // 원격제어 모달
  iconBorderColor: '#f2aa4c',
  // scroll-bar
  scrollbarThumbColor: '#cccccc',
  scrollbarTrackColor: '#ececec',
  // range-bar
  sliderRunnableTrackColor: '#d8d8d9',

  textColor: '#121212',
  bgColor: '#f5f5f5',
  borderColor: '#D3D4D7',
  subContainerBgColor: '#ecedf0', // layer2

  buttonBgColor: '#e0e0e0',
  buttonActiveBgColor: '#242424',
};
